(function() {
    'use strict';
    angular.module('Directives').directive('bbaGoodsCheckDirective', bbaGoodsCheckDirective);

    function bbaGoodsCheckDirective() {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/bbaGoodsCheckDirective.html',
            replace: true,
            scope: {
                shipment: '=',
            },
            link: bbaGoodsCheckDirectiveLink
        }

        function bbaGoodsCheckDirectiveLink($scope, $element, $attrs) {
            init();

            function init() {
                $scope.$watch('shipment', function(data) {
                    $scope.data = data;
                    if (data) {
                        setATLSRValues();
                    }
                });
            }

            function setATLSRValues() {
                if ($scope.data.unattendedDelivery === null) {
                    $scope.data.authorityToLeave = false;
                    $scope.data.signatureRequired = false;
                    return;
                }

                if ($scope.data.unattendedDelivery === true) {
                    $scope.data.authorityToLeave = true;
                    $scope.data.signatureRequired = false;
                }

                if ($scope.data.unattendedDelivery === false) {
                    $scope.data.authorityToLeave = false;
                    $scope.data.signatureRequired = true;
                }
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/bbaGoodsCheckDirective.js